var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"id":"date-picker-ffgd06","label":_vm.properties.label}},[_c('date-picker',{attrs:{"id":"date-picker-60ywii","size":"sm"},model:{value:(_vm.propertyValue),callback:function ($$v) {_vm.propertyValue=$$v},expression:"propertyValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }